import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { FILTER_TYPE } from "constant/product-filter.action";
import { FILTER_LABEL_MAP } from "modules/category/constants/filter-constants";
import { useTranslation } from "next-i18next";
import { isArray } from "../../util/helper/isArray";
import { capitalize } from "../../util/lodash/capitalize";

function ProductFilterSummaryValue({
  filterKey, item, filterOptions, capitalizeValue,
}) {
  const { t } = useTranslation(["category", "category-map"]);
  const catMapT = (_: string) => t(_, { ns: "category-map" });

  let value = "";
  switch (filterKey) {
  case FILTER_TYPE.SIZES:
    value = item;
    break;
  case FILTER_TYPE.PRICE:
    if (isArray(filterOptions.prices)) {
      filterOptions.prices.forEach((bucket: any) => {
        const parse = `${bucket.from}-${bucket.to}`;
        if (item === parse) {
          value = capitalizeValue ? capitalize(bucket.bucket) : bucket.buket;
        }
      });
    }
    break;
  case FILTER_TYPE.TAGS:
  case FILTER_TYPE.MERCHANDISE_SIZES:
  case FILTER_TYPE.CUSTOMTIRESIZE:
    value = item;
    break;
  default:
    value = capitalizeValue ? capitalize(item) : item;
    break;
  }
  return (
    <PAText fontSize={FONT_SIZE[0]} component="b" className="text-capitalize">
      {
        FILTER_LABEL_MAP[filterKey] === "Category" ? catMapT(value) : t(value)
      }
    </PAText>
  );
}

export default ProductFilterSummaryValue;
